import Vue from 'vue'
const exportProject = {
    label: Vue.prototype.$t( "label_export_to_robot" ),
    funcName: "exportProject$",
    multiSelect: false
}
const uploadProject = {
    label: Vue.prototype.$t("label_upload"),
    funcName: "uploadProject$",
    multiSelect: false,
    alwaysShow: true
};
const downloadProject = {
    label: Vue.prototype.$t("label_download"),
    funcName: "downloadProject$",
    multiSelect: false
}
const editProjectOpenStatus = {
    label: Vue.prototype.$t( "code-lab/component/file-management/mixins/project-folder-crud.js_35" ),
    funcName: "editProjectOpenStatus$",
    multiSelect: true,
    preSplit: true
}
const moveProject = {
    label: Vue.prototype.$t( "code-lab/component/file-management/observable/tableToolOber.js_2" ),
    funcName: "moveProject$",
    multiSelect: true,
    preSplit: true
}
const renameProject = {
    label: Vue.prototype.$t( "code-lab/component/file-management/observable/tableToolOber.js_0" ),
    funcName: "renameProject$",
    multiSelect: false
}
const deleteProject = {
    label: Vue.prototype.$t( "code-lab/component/file-management/observable/tableToolOber.js_3" ),
    funcName: "deleteProject$",
    multiSelect: true,
    preSplit: true
}
const editFolderOpenStatus = {
    label: Vue.prototype.$t( "code-lab/component/file-management/mixins/project-folder-crud.js_35" ),
    funcName: "editFolderOpenStatus$",
    multiSelect: true
}
const moveFolder = {
    label: Vue.prototype.$t( "code-lab/component/file-management/observable/tableToolOber.js_5" ),
    funcName: "moveFolder$",
    multiSelect: true
}
const renameFolder = {
    label: Vue.prototype.$t( "code-lab/component/file-management/observable/tableToolOber.js_4" ),
    funcName: "renameFolder$",
    multiSelect: false
}
const deleteFolder = {
    label: Vue.prototype.$t( "code-lab/component/file-management/observable/tableToolOber.js_6" ),
    funcName: "deleteFolder$",
    multiSelect: true,
    preSplit: true
}

const state = {
    family: {
        projectTableTool: [
            exportProject,
            downloadProject,
            moveProject,
            renameProject,
            deleteProject
        ],
        idTableTool: [
            moveFolder,
            renameFolder,
            deleteFolder
        ]
    },
    student: {
        projectTableTool: [
            exportProject,
            downloadProject,
            moveProject,
            renameProject,
            deleteProject
        ],
        idTableTool: [
            moveFolder,
            renameFolder,
            deleteFolder
        ]
    },
    teacher: {
        my: {
            projectTableTool:[
                exportProject,
                uploadProject,
                downloadProject,
                editProjectOpenStatus,
                moveProject,
                renameProject,
                deleteProject
            ] ,
            idTableTool: [
                editFolderOpenStatus,
                moveFolder,
                renameFolder,
                deleteFolder
            ]
        },
        shared: {
            projectTableTool: [
                exportProject,
                uploadProject,
                downloadProject
            ],    
            idTableTool: []
        }
    }
}

export const store = Vue.observable(state)

export const mutations = {}
